import { render, staticRenderFns } from "./product-layout.vue?vue&type=template&id=aeed78b4"
import script from "./product-layout.vue?vue&type=script&lang=ts"
export * from "./product-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports